import { resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, resolveDirective as _resolveDirective, withDirectives as _withDirectives, withCtx as _withCtx, createTextVNode as _createTextVNode, withModifiers as _withModifiers, Teleport as _Teleport, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "p-0 bg-gray-50 shadow-xl border border-gray-200 rounded-md text-center" }
const _hoisted_2 = { class: "flex flex-col w-full text-black" }
const _hoisted_3 = {
  key: 0,
  class: "absolute inset-0 flex items-center justify-center z-50 bg-black/20"
}
const _hoisted_4 = { class: "flex flex-col w-full rounded-t-md p-3 bg-gradient-to-r from-[#424c42] to-[#647064]" }
const _hoisted_5 = { class: "font-semibold text-white text-sm md:text-2xl truncate whitespace-nowrap overflow-hidden text-ellipsis" }
const _hoisted_6 = { class: "container p-4 text-left" }
const _hoisted_7 = { class: "flex flex-wrap -mx-2 space-y-4 md:space-y-0 mt-5" }
const _hoisted_8 = { class: "w-full px-2" }
const _hoisted_9 = { class: "ql-formats" }
const _hoisted_10 = { class: "ql-bold" }
const _hoisted_11 = { class: "ql-italic" }
const _hoisted_12 = { class: "ql-underline" }
const _hoisted_13 = { class: "p-3 flex flex-col md:flex-row gap-2 justify-end w-full mt-5 bg-gray-100" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_ProgressSpinner = _resolveComponent("ProgressSpinner")!
  const _component_font_awesome_icon = _resolveComponent("font-awesome-icon")!
  const _component_Editor = _resolveComponent("Editor")!
  const _component_BlockUI = _resolveComponent("BlockUI")!
  const _directive_tooltip = _resolveDirective("tooltip")!

  return (_openBlock(), _createBlock(_Teleport, { to: "body" }, [
    _createElementVNode("div", {
      class: "fixed inset-0 z-50 overflow-y-auto bg-black/60 flex justify-center p-2 sm:p-5",
      onClick: _cache[4] || (_cache[4] = _withModifiers(($event: any) => (_ctx.closeDialog(false)), ["self"]))
    }, [
      _createElementVNode("div", {
        class: "w-full md:w-8/12 lg:w-6/12 my-auto",
        onClick: _cache[3] || (_cache[3] = _withModifiers(($event: any) => (_ctx.closeDialog(false)), ["self"]))
      }, [
        _createElementVNode("div", _hoisted_1, [
          _createElementVNode("div", _hoisted_2, [
            _createVNode(_component_BlockUI, { visible: _ctx.blocked }, {
              default: _withCtx(() => [
                (_ctx.blocked)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_3, [
                      _createVNode(_component_ProgressSpinner, {
                        style: {"width":"50px","height":"50px"},
                        strokeWidth: "5",
                        fill: "transparent",
                        animationDuration: ".5s"
                      })
                    ]))
                  : _createCommentVNode("", true),
                _createElementVNode("div", _hoisted_4, [
                  _createElementVNode("div", null, [
                    _createVNode(_component_font_awesome_icon, {
                      icon: ['fas', 'fa-info'],
                      class: "w-6 h-6 text-white"
                    })
                  ]),
                  _createElementVNode("div", _hoisted_5, _toDisplayString(_ctx.$t('titulo.editar.resumen.empresa')), 1)
                ]),
                _createElementVNode("div", _hoisted_6, [
                  _createElementVNode("div", _hoisted_7, [
                    _createElementVNode("div", _hoisted_8, [
                      _createVNode(_component_Editor, {
                        modelValue: _ctx.formData.breveDescripcion,
                        "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.formData.breveDescripcion) = $event)),
                        editorStyle: "height: 320px"
                      }, {
                        toolbar: _withCtx(() => [
                          _createElementVNode("span", _hoisted_9, [
                            _withDirectives(_createElementVNode("button", _hoisted_10, null, 512), [
                              [
                                _directive_tooltip,
                                'Bold',
                                void 0,
                                { bottom: true }
                              ]
                            ]),
                            _withDirectives(_createElementVNode("button", _hoisted_11, null, 512), [
                              [
                                _directive_tooltip,
                                'Italic',
                                void 0,
                                { bottom: true }
                              ]
                            ]),
                            _withDirectives(_createElementVNode("button", _hoisted_12, null, 512), [
                              [
                                _directive_tooltip,
                                'Underline',
                                void 0,
                                { bottom: true }
                              ]
                            ])
                          ])
                        ]),
                        _: 1
                      }, 8, ["modelValue"])
                    ])
                  ])
                ]),
                _createElementVNode("div", _hoisted_13, [
                  _createElementVNode("a", {
                    onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.closeDialog(false))),
                    class: "cursor-pointer px-6 text-sm font-bold text-red-500 bg-transparent py-3 border border-red-500 shadow-md rounded-xl transform transition-transform duration-200 hover:scale-105 active:scale-95"
                  }, [
                    _createVNode(_component_font_awesome_icon, { icon: ['fas', 'fa-xmark'] }),
                    _createTextVNode(" " + _toDisplayString(_ctx.$t('boton.cancelar')), 1)
                  ]),
                  _createElementVNode("a", {
                    onClick: _cache[2] || (_cache[2] = 
//@ts-ignore
(...args) => (_ctx.aplicarCambios && _ctx.aplicarCambios(...args))),
                    class: "cursor-pointer px-6 text-sm font-bold text-[#424c42] bg-transparent py-3 border border-[#424c42] shadow-md rounded-xl transform transition-transform duration-200 hover:scale-105 active:scale-95"
                  }, [
                    _createVNode(_component_font_awesome_icon, { icon: ['fas', 'fa-check-double'] }),
                    _createTextVNode(" " + _toDisplayString(_ctx.$t('boton.aplicar.cambios')), 1)
                  ])
                ])
              ]),
              _: 1
            }, 8, ["visible"])
          ])
        ])
      ])
    ])
  ]))
}